export default __webpack_public_path__ + "static/ecom_5-b6051afbe4310ad55063314207cbf9b5.jpeg";